export { default } from './Truncate';